import React, { Component } from 'react';
import moment from 'moment';
import AppContainer from '../../../../components/AppContainer';
import PBIcon from '../../../../components/PBIcon';
import ActivityDetail from '../../../../components/ActivityDetail';
import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import { DATE_FORMATS } from '@progressivebeef/shared/src/constants/AppConstants';
import withRouter from '../../../../routes/withRouter';

import './style.scss';

class RemovedInstance extends Component {
  renderLeftHeader = () => {
    return (
      <div className="head-icon left-align">
        <PBIcon
          name={'chevron-left'}
          onPress={() => {
            this.props.history.goBack();
          }}
        />
      </div>
    );
  };

  render() {
    // Check if location state exists, provide fallbacks if not
    const locationState = this.props.location.state || {};
    const {
      instance = {},
      instanceName = 'Instance',
      currentActivity = {},
    } = locationState;
    
    // Handle cases where instance or its nested properties might be undefined
    const userName = instance.removed_by && instance.removed_by.profile
      ? `${instance.removed_by.profile.first_name} ${instance.removed_by.profile.last_name}`
      : '';
    const { history } = this.props;
    
    // If no state is available, redirect back or show error
    if (!this.props.location.state) {
      return (
        <AppContainer
          noncollapsible
          title="Error"
          iconHeader
          history={history}
          IconLeftHeader={this.renderLeftHeader}
        >
          <div className="error-container">
            <h3>No instance data available</h3>
            <p>Please navigate back and try again.</p>
          </div>
        </AppContainer>
      );
    }
    
    return (
      <AppContainer
        noncollapsible
        title={instanceName}
        iconHeader
        history={history}
        IconLeftHeader={this.renderLeftHeader}
      >
        <div>
          <ActivityDetail activity={currentActivity} />
        </div>
        <div className="instance-remove-box">
          <div className="head">
            <div className="icon">
              <PBIcon name="info-circle" />
            </div>
            <div className="label">{' ' + (instance.instance_value || 'N/A')}</div>
          </div>
          <div className="highlight-msg">{instance.reason || 'No reason provided'}</div>
          <div className="deleted-info-box">
            <div className="box">
              {userName && <div>{localization[getLocale()].INSTANCE_DELETED_BY}</div>}
              {instance.removed_date_time && <div>{localization[getLocale()].DATE}</div>}
            </div>
            <div className="box">
              <div className="user-style">{userName || 'Unknown'}</div>
              <div>
                {instance.removed_date_time && 
                  moment(instance.removed_date_time).format(DATE_FORMATS.MM_DD_YY)}
                {instance.removed_date_time && ' | '}
                {instance.removed_date_time && 
                  moment(instance.removed_date_time).format(DATE_FORMATS.H_MM_A)}
              </div>
            </div>
          </div>
        </div>
      </AppContainer>
    );
  }
}

export default withRouter(RemovedInstance);
